import React , { useContext , useEffect , useState } from 'react';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Button, ModalBody, Form, Label, Input, Modal, ModalHeader,
    FormGroup, FormFeedback}                                                    from "reactstrap";
import { useMutation , useQuery , useQueryClient } from "@tanstack/react-query";
import {toast} from "react-toastify";
import Loader from "../../components/Loader";
import handleUnauthorized401MutateError from "../../utils/handleUnauthorized401MutateError";
import AuthContext from "../../context/AuthContext";
import {
    changeCouponInventoryTrackingStatus,
    changeCouponStatus, couponStockUpdate,
    editCoupon,
    getCustomers,
    getProducts
} from "../../api/api";
import Select from "react-select";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";

import CouponStockModal from "./CouponStockModal";

function ActionButton(props) {

    const {refreshToken} = useContext(AuthContext);
    const [actionButtonDropdownOpen, setActionButtonDropdownOpen] = useState(false);
    // const toggleActionButtonDropdown = () => {
    //     setActionButtonDropdownOpen(prevState => {
    //         const newDropdownState = !prevState;
    //         document.querySelector('.table-responsive').classList.toggle('dropdown-open', newDropdownState);
    //         return newDropdownState;
    //     });
    // };
    const toggleActionButtonDropdown = () => setActionButtonDropdownOpen((prevState) => !prevState);
    const [couponUpdateToggle, setCouponUpdateToggle] = useState(false);
    const toggleCouponUpdateModal = () => setCouponUpdateToggle(prevState => !prevState);

    const [couponName, setCouponName] = useState(props.coupon.name);
    const [couponCode, setCouponCode] = useState(props.coupon.code);
    const [couponValue, setCouponValue] = useState(props.coupon.value);
    // const [couponType, setCouponType] = useState(props.coupon.type || 'FLAT');
    const [couponPercentage, setCouponPercentage] = useState(props.coupon.percentage);
    // const [couponStock, setCouponStock] = useState(props.coupon.stock);
    const [couponStock, setCouponStock] = useState('');
    const [couponMinimumCartValue, setCouponMinimumCartValue] = useState(props.coupon.minimum_cart_value);
    const [couponMaxValue, setCouponMaxValue] = useState(props.coupon.max_coupon_value);
    const [couponEligibleForFirstOrder, setCouponEligibleForFirstOrder] = useState(props.coupon.eligible_for_first_order_only);
    // const [couponApplicableTo, setCouponApplicableTo] = useState(props.coupon.applicable_to || '');

    const [stockTransactionType, setStockTransactionType] = useState('CR');
    const [couponStockTransactionName, setCouponStockTransactionName] = useState('');

    const [customersSupported, setCustomersSupported] = useState(
        props.coupon.eligible_customers.map(customer => ({
            value: customer,
            label: customer
        }))
    );
    const [customerOptions, setCustomerOptions] = useState([]);
    const [customerRecords, setCustomerRecords] = useState(1);

    const [productsSupported, setProductsSupported] = useState(
        props.coupon.eligible_products.map(products => ({
            value: products,
            label: products
        }))
    );
    const [productOptions, setProductOptions] = useState([]);
    const [productRecords, setProductRecords] = useState(1);
    const [advancedOptions, setAdvancedOptions] = useState(false);
    const [stockHistoryModal, setStockHistoryModal] = useState(false);
    const stockHistoryModaltoggle = () => setStockHistoryModal(!stockHistoryModal);
    const [couponStockUpdateToggle, setCouponStockUpdateToggle] = useState(false);
    const toggleStockUpdateModal = () =>
        setCouponStockUpdateToggle((prevState) => !prevState);
    const page = 1;

    const queryClient = useQueryClient();

    useEffect(() => {
        const formattedCustomers = props.coupon.eligible_customers.map(customer => ({
            value: customer,
            label: customer
        }));
        setCustomersSupported(formattedCustomers);
        setCustomerOptions(formattedCustomers);
    }, [couponUpdateToggle, props.coupon.eligible_customers]);

    useEffect(() => {
        const formattedCustomers = props.coupon.eligible_products.map(products => ({
            value: products,
            label: products
        }));
        setProductsSupported(formattedCustomers);
        setProductOptions(formattedCustomers);
    }, [couponUpdateToggle, props.coupon.eligible_products]);

    const { refetch: refetchCustomers } = useQuery({
        queryKey: ['customers', customerRecords],
        queryFn: () => getCustomers(page, '', '', '', '', '', '', '', '', '', '', customerRecords),
        keepPreviousData: true,
        retry: false,
        refetchOnWindowFocus: couponUpdateToggle,
        enabled: couponUpdateToggle,
        onSuccess: (data) => {
            setCustomerRecords(data?.count);
            const newOptions = data?.results?.map(customer => ({
                value: customer.email,
                label: customer.email
            })) || [];
            setCustomerOptions(newOptions);
        },
        onError: (err) => {
            handleUnauthorized401QueryError(err, refreshToken, refetchCustomers);
            if (err.response.status !== 401) {
                toast.error(`An error occurred! ${err?.response?.data?.detail}`);
            }
        }
    });

    const { refetch: refetchProducts } = useQuery({
        queryKey: ['products', productRecords],
        queryFn: () => getProducts(page, '', '', '', '', '', '', '', '', '', '', '', '', '', '', productRecords),
        keepPreviousData: true,
        retry: false,
        refetchOnWindowFocus: couponUpdateToggle,
        enabled: couponUpdateToggle,
        onSuccess: (data) => {
            setProductRecords(data?.count);
            const newOptions = data?.results?.map(product => ({
                value: product.name,
                label: product.name
            })) || [];
            setProductOptions(newOptions);
        },
        onError: (err) => {
            handleUnauthorized401QueryError(err, refreshToken, refetchProducts);
            if (err.response.status !== 401) {
                toast.error(`An error occurred! ${err?.response?.data?.detail}`);
            }
        }
    });

    const onSelectCustomers = (selectedCustomerOptions) => {
        setCustomersSupported(selectedCustomerOptions);
    };

    const onSelectProducts = (selectedProductOptions) => {
        setProductsSupported(selectedProductOptions);
    };

    const changeCouponStatusMutation = useMutation({
        mutationFn: changeCouponStatus,
        onSuccess: () => {
            queryClient.invalidateQueries(['coupons']);
            toast.success('Coupon Status Changed!');
        },
        onError: (err) => {
            handleUnauthorized401MutateError(err, refreshToken, changeCouponStatusMutation);
            if (err.response.status !== 401) {
                toast.error(`An error occurred! ${err?.response?.data?.detail}`);
            }
        }
    });

    const changeCouponInventoryTrackingStatusMutation = useMutation({
        mutationFn: changeCouponInventoryTrackingStatus,
        onSuccess: () =>{
            queryClient.invalidateQueries(['coupons'])
            toast.success('Coupon Inventory Status Changed!')
        },
        // onError: error => {
        //     toast.error(`An error occurred! ${err?.response?.data?.detail}`)
        // },
        onError: (err, variables) => {
            handleUnauthorized401MutateError(err, refreshToken, changeCouponInventoryTrackingStatusMutation, variables)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }
    })

    const editCouponMutation = useMutation({
        mutationFn: editCoupon,
        onSuccess: (data) => {
            toggleCouponUpdateModal();
            queryClient.invalidateQueries(['coupons']);
            const formattedCustomers = data.eligible_customers.map(customer => ({
                value: customer,
                label: customer
            }));
            setCustomersSupported(formattedCustomers);
            const formattedProducts = data.eligible_products.map(product => ({
                value: product,
                label: product
            }));
            setProductsSupported(formattedProducts)
            toast.success('Coupon updated!');
        },
        onError: (err) => {
            handleUnauthorized401MutateError(err, refreshToken, editCouponMutation);
            if (err.response.status !== 401) {
                toast.error(`An error occurred! ${err?.response?.data?.detail}`);
            }
        }
    });

    const couponStockUpdateMutation = useMutation({
        mutationFn: couponStockUpdate,
        onSuccess: (data, variables) =>{
            toggleStockUpdateModal()
            setCouponStockTransactionName('')
            setCouponStock('')
            setStockTransactionType('CR')
            queryClient.invalidateQueries(['coupons'])
            toast.success('Coupon Stock updated!')
        },
        // onError: err => {
        //     toast.error(`An error occurred! ${err?.response?.data?.detail}`)
        // }
        onError: (err, variables) => {
            handleUnauthorized401MutateError(err, refreshToken, couponStockUpdateMutation, variables)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }
    })

    const handleChangeCouponInventoryTrackingStatus = async (coupon) => {
        let couponInventoryTrackingStatus = {
            is_inventory_tracking_enabled: coupon.is_inventory_tracking_enabled === true ? false : true,
        };
        changeCouponInventoryTrackingStatusMutation.mutate({
            couponInventoryTrackingStatus: couponInventoryTrackingStatus, couponId: coupon.id
        })
    }

    const handleChangeCouponStatus = () => {
        const couponStatus = { status: props.coupon.status === 'ACTIVE' ? 'REVOKED' : 'ACTIVE' };
        changeCouponStatusMutation.mutate({ couponStatus, couponId: props.coupon.id });
    };

    const handleEditCoupon = async (e) => {
        e?.preventDefault();
        // const formData = new FormData();
        // formData.append('name', couponName);
        // formData.append('code', couponCode);
        // if (couponValue) formData.append('value', couponValue);
        // formData.append('type', couponType);
        // if (couponPercentage) formData.append('percentage', couponPercentage);
        // if (couponStock) formData.append('stock', couponStock);
        // if (couponMinimumCartValue) formData.append('minimum_cart_value', couponMinimumCartValue);
        // if (couponMaxValue) formData.append('max_coupon_value', couponMaxValue);
        // formData.append('eligible_for_first_order_only', couponEligibleForFirstOrder);
        // formData.append('applicable_to', couponApplicableTo);
        // customersSupported.forEach(customer => {formData.append('eligible_customers', customer.value)});
        // productsSupported.forEach(product => {formData.append('eligible_products', product.value)});

        // if (customersSupported.length > 0) {
        //     customersSupported.forEach(customer => {
        //         formData.append('eligible_customers', customer.value);
        //     });
        // } else {
        //     formData.append('eligible_customers', []);  // explicitly empty
        // }
        //
        // if (productsSupported.length > 0) {
        //     productsSupported.forEach(product => {
        //         formData.append('eligible_products', product.value);
        //     });
        // } else {
        //     formData.append('eligible_products', []);  // explicitly empty
        // }

        const payload = {
            name: couponName,
            code: couponCode,
            value: couponValue || null,
            // type: couponType,
            percentage: couponPercentage || null,
            // stock: couponStock || null,
            minimum_cart_value: couponMinimumCartValue || null,
            max_coupon_value: couponMaxValue || null,
            eligible_for_first_order_only: couponEligibleForFirstOrder,
            // applicable_to: couponApplicableTo,
            // eligible_customers: [],  // this will be []
            // eligible_products: [],    // this will be []
            eligible_customers: customersSupported.map(c => c.value),
            eligible_products: productsSupported.map(p => p.value),
        };

        editCouponMutation.mutate({payload, couponId: props.coupon.id });

        // editCouponMutation.mutate({ formData, couponId: props.coupon.id });
    };

    const handleCouponStockUpdate = async (coupon, e) => {
        e?.preventDefault();
        const formData = new FormData();
        if (couponStockTransactionName) formData.append("name", couponStockTransactionName);
        formData.append("coupon", coupon.id);
        formData.append("stock", couponStock);
        formData.append("type", stockTransactionType);

        couponStockUpdateMutation.mutate({
            formData: formData, couponId: coupon.id
        })
    }

    return (
        <td className="text-center">
            <Dropdown
                nav
                isOpen={actionButtonDropdownOpen}
                toggle={toggleActionButtonDropdown}
                className="btn-group dropdown"
            >
                <DropdownToggle
                    caret
                    className="dropdown-toggle arrow-none btn btn-light btn-sm"
                >
                    <i className="mdi mdi-dots-horizontal"/>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-right profile-dropdown">
                    <DropdownItem
                        className="dropdown-item"
                        onClick={toggleCouponUpdateModal}
                    >
                        <i className="mdi mdi-pencil mr-2 text-muted font-18 vertical-middle"/>
                        <span>Edit Coupon</span>
                    </DropdownItem>

                    <DropdownItem
                        className="dropdown-item"
                        onClick={() => handleChangeCouponStatus(props.coupon)}
                    >
                        <i className="mdi mdi-delete mr-2 text-muted font-18 vertical-middle"/>
                        <span>
                                {props.coupon.status === "ACTIVE"
                                    ? "REVOKE"
                                    : "Make ACTIVE"}
                            </span>
                    </DropdownItem>

                    <DropdownItem
                        className="dropdown-item"
                        onClick={() => handleChangeCouponInventoryTrackingStatus(props.coupon)}
                    >
                        <i className="mdi mdi-stocking mr-2 text-muted font-18 vertical-middle"/>
                        <span>
                                {props.coupon.is_inventory_tracking_enabled === true
                                    ? "Disable Inventory Tracking"
                                    : "Enable Inventory Tracking"}
                            </span>
                    </DropdownItem>

                    {props.coupon.is_inventory_tracking_enabled && (
                        <DropdownItem
                            className="dropdown-item"
                            onClick={toggleStockUpdateModal}
                        >
                            <i className="mdi mdi-update mr-2 text-muted font-18 vertical-middle"/>
                            <span>Update Stock</span>
                        </DropdownItem>
                    )}
                    {props.coupon.is_inventory_tracking_enabled && (
                        <DropdownItem
                            className="dropdown-item"
                            onClick={stockHistoryModaltoggle}
                        >
                            <i className="fe-box mr-2 text-muted font-18 vertical-middle"/>
                            <span>View Stock</span>
                        </DropdownItem>
                    )}

                </DropdownMenu>
            </Dropdown>

            <CouponStockModal coupon={props.coupon} modal={stockHistoryModal} modalToggle={stockHistoryModaltoggle}/>

            <Modal
                isOpen={couponStockUpdateToggle}
                toggle={toggleStockUpdateModal}
            >
                <ModalHeader toggle={toggleStockUpdateModal} close={
                    <button className="close" onClick={toggleStockUpdateModal}>
                        &times;
                    </button>
                }>
                    Update Coupon Stock: {props.coupon.code}
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={(e) => handleCouponStockUpdate(props.coupon, e)}>
                        <FormGroup>
                            <Label for="Name">Name</Label>
                            <Input
                                type="text"
                                name="stockTransactionname"
                                id="stockTransactionname"
                                placeholder="Stock Transaction Name"
                                // defaultValue={props.product.name}
                                onChange={(e) =>
                                    setCouponStockTransactionName(e.target.value)
                                }
                                invalid={
                                    couponStockUpdateMutation.isError &&
                                    couponStockUpdateMutation.error.response.data.name
                                }
                            />
                            {couponStockUpdateMutation.isError && couponStockUpdateMutation.error.response.data.name && (
                                <FormFeedback invalid>
                                    {couponStockUpdateMutation.error.response.data.name}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label for="Stock">Stock<span className="text-danger">*</span></Label>
                            <Input
                                type="text"
                                name="stock"
                                id="stock"
                                placeholder="Stock"
                                // defaultValue={props.product.price}
                                onChange={(e) =>
                                    setCouponStock(e.target.value)
                                }
                                invalid={
                                    couponStockUpdateMutation.isError &&
                                    couponStockUpdateMutation.error.response.data.stock
                                }
                            />
                            {couponStockUpdateMutation.isError && couponStockUpdateMutation.error.response.data.stock && (
                                <FormFeedback invalid>
                                    {couponStockUpdateMutation.error.response.data.stock}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label for="type">Type<span className="text-danger">*</span></Label>
                            <Input
                                type="select"
                                name="select"
                                id="type"
                                className={"form-control"}
                                defaultValue={stockTransactionType}
                                onChange={(e) =>
                                    setStockTransactionType(e.target.value)
                                }
                                invalid={
                                    couponStockUpdateMutation.isError &&
                                    couponStockUpdateMutation.error.response.data.type
                                }
                            >
                                <option value={'CR'}>
                                    CREDIT
                                </option>
                                <option value={'DR'}>
                                    DEBIT
                                </option>
                            </Input>
                            {couponStockUpdateMutation.isError && couponStockUpdateMutation.error.response.data.type && (
                                <FormFeedback invalid>
                                    {couponStockUpdateMutation.error.response.data.type}
                                </FormFeedback>
                            )}
                        </FormGroup>

                        <Button
                            color="#4d5bed"
                            className="bx-btn-primary"
                            block
                            disabled={couponStockUpdateMutation.isLoading}
                        >
                            {couponStockUpdateMutation.isLoading? <><Loader size={'small'}/> Updating Stock...</>: `Update Stock`}

                        </Button>
                    </Form>
                </ModalBody>
            </Modal>

            <Modal
                isOpen={couponUpdateToggle}
                toggle={toggleCouponUpdateModal}
                className=""
            >
                <ModalHeader toggle={toggleCouponUpdateModal} close={
                    <button className="close" onClick={toggleCouponUpdateModal}>
                        &times;
                    </button>
                }>
                    Update Coupon
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleEditCoupon}>
                        <FormGroup>
                            <Label for="product-group-price">Code<span className="text-danger">*</span></Label>
                            <Input
                                type="text"
                                name="coupon-code"
                                id="coupon-code"
                                placeholder="Coupon Code"
                                value={couponCode}
                                onChange={(e) =>
                                    setCouponCode(e.target.value)
                                }
                                invalid={
                                    editCouponMutation.isError &&
                                    editCouponMutation.error.response.data.code
                                }
                            />
                            {editCouponMutation.isError && editCouponMutation.error.response.data.code && (
                                <FormFeedback invalid>
                                    {editCouponMutation.error.response.data.code}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        {/*<FormGroup>*/}
                        {/*    <Label for="coupon-type">Type<span className="text-danger">*</span></Label>*/}
                        {/*    <Input*/}
                        {/*        type="select"*/}
                        {/*        name="coupon-type"*/}
                        {/*        id="coupon-type"*/}
                        {/*        className={"form-control"}*/}
                        {/*        placeholder="Coupon Type"*/}
                        {/*        value={couponType}*/}
                        {/*        onChange={(e) =>*/}
                        {/*            setCouponType(e.target.value)*/}
                        {/*        }*/}
                        {/*        invalid={*/}
                        {/*            editCouponMutation.isError &&*/}
                        {/*            editCouponMutation.error.response.data.type*/}
                        {/*        }*/}
                        {/*    >*/}
                        {/*        <option value={'FLAT'}>*/}
                        {/*            Flat*/}
                        {/*        </option>*/}
                        {/*        <option value={'PERCENTAGE'}>*/}
                        {/*            Percentage*/}
                        {/*        </option>*/}
                        {/*    </Input>*/}
                        {/*    {editCouponMutation.isError && editCouponMutation.error.response.data.type && (*/}
                        {/*        <FormFeedback invalid>*/}
                        {/*            {editCouponMutation.error.response.data.type}*/}
                        {/*        </FormFeedback>*/}
                        {/*    )}*/}
                        {/*</FormGroup>*/}
                        {props.coupon.type === 'PERCENTAGE' ? (
                            <FormGroup>
                                <Label for="coupon-percentage">Percentage<span className="text-danger">*</span></Label>
                                <Input
                                    type="text"
                                    name="coupon-percentage"
                                    id="coupon-percentage"
                                    placeholder="Coupon Percentage"
                                    value={couponPercentage}
                                    onChange={(e) => setCouponPercentage(e.target.value)}
                                    invalid={
                                        editCouponMutation.isError &&
                                        editCouponMutation.error.response.data.percentage
                                    }
                                />
                                {editCouponMutation.isError && editCouponMutation.error.response.data.percentage && (
                                    <FormFeedback invalid>
                                        {editCouponMutation.error.response.data.percentage}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        ) : null}

                        {/* Hide the "Value" input field when "Percentage" is selected */}
                        {props.coupon.type !== 'PERCENTAGE' && (
                            <FormGroup>
                                <Label for="coupon-value">Value<span className="text-danger">*</span></Label>
                                <Input
                                    type="text"
                                    name="coupon-value"
                                    id="coupon-value"
                                    placeholder="Coupon Value"
                                    value={couponValue}
                                    onChange={(e) => setCouponValue(e.target.value)}
                                    invalid={
                                        editCouponMutation.isError &&
                                        editCouponMutation.error.response.data.value
                                    }
                                />
                                {editCouponMutation.isError && editCouponMutation.error.response.data.value && (
                                    <FormFeedback invalid>
                                        {editCouponMutation.error.response.data.value}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        <FormGroup className="form-group mb-3">
                            <div className="custom-control custom-checkbox">
                                <Input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="checkbox-advanced-options"
                                    checked={advancedOptions}
                                    onChange={() => setAdvancedOptions(!advancedOptions)}
                                />
                                <Label
                                    className="custom-control-label"
                                    for="checkbox-advanced-options"
                                >
                                    Advanced Options
                                </Label>
                            </div>
                        </FormGroup>
                        {advancedOptions && (
                            <FormGroup>
                                <Label for="coupon-name">Coupon Name</Label>
                                <Input
                                    type="text"
                                    name="coupon-name"
                                    id="coupon-name"
                                    placeholder="Coupon Name"
                                    value={couponName}
                                    onChange={(e) =>
                                        setCouponName(e.target.value)
                                    }
                                    invalid={
                                        editCouponMutation.isError &&
                                        editCouponMutation.error.response.data.name
                                    }
                                />
                                {editCouponMutation.isError && editCouponMutation.error.response.data.name && (
                                    <FormFeedback invalid>
                                        {editCouponMutation.error.response.data.name}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {advancedOptions && (
                            <FormGroup>
                                <Label for="customers">
                                    Select Customer (Ignore If Coupon is Universal)
                                </Label>
                                <Select
                                    options={customerOptions}
                                    isMulti
                                    noOptionsMessage={() => "No Customer(s) found!"}
                                    placeholder="Select Customers..."
                                    defaultValue={customersSupported}
                                    onChange={onSelectCustomers}
                                    styles={{
                                        control: (baseStyles) => (
                                            {
                                                ...baseStyles,
                                                borderColor: "#495561",
                                                backgroundColor: "#414d59",
                                                color: "white",
                                                padding: "0.45 0.9",
                                                border: 'none',
                                                boxShadow: 'none'
                                            }
                                        ),
                                        menu: (baseStyles) => (
                                            {
                                                ...baseStyles,
                                                backgroundColor: "#414d59",
                                                color: "#a8b5c3"
                                            }
                                        ),
                                        input: (baseStyles) => (
                                            {
                                                ...baseStyles,
                                                color: "white"
                                            }
                                        )
                                    }}

                                />
                            </FormGroup>
                        )}
                        {advancedOptions && (
                            <FormGroup>
                                <Label for="customers">
                                    Select Products (Ignore If Coupon is Universal)
                                </Label>
                                <Select
                                    options={productOptions}
                                    isMulti
                                    noOptionsMessage={() => "No Product(s) found!"}
                                    placeholder="Select Products..."
                                    defaultValue={productsSupported}
                                    onChange={onSelectProducts}
                                    styles={{
                                        control: (baseStyles) => (
                                            {
                                                ...baseStyles,
                                                borderColor: "#495561",
                                                backgroundColor: "#414d59",
                                                color: "white",
                                                padding: "0.45 0.9",
                                                border: 'none',
                                                boxShadow: 'none'
                                            }
                                        ),
                                        menu: (baseStyles) => (
                                            {
                                                ...baseStyles,
                                                backgroundColor: "#414d59",
                                                color: "#a8b5c3"
                                            }
                                        ),
                                        input: (baseStyles) => (
                                            {
                                                ...baseStyles,
                                                color: "white"
                                            }
                                        )
                                    }}

                                />
                            </FormGroup>
                        )}
                        {advancedOptions && props.coupon.type !== 'FLAT' && (
                            <FormGroup>
                                <Label for="coupon-max_value">Maximum Coupon Value</Label>
                                <Input
                                    type="text"
                                    name="coupon-max_value"
                                    id="coupon-max_value"
                                    placeholder="Coupon Max Value"
                                    value={couponMaxValue}
                                    onChange={(e) =>
                                        setCouponMaxValue(e.target.value)
                                    }
                                    invalid={
                                        editCouponMutation.isError &&
                                        editCouponMutation.error.response.data.max_coupon_value
                                    }
                                />
                                {editCouponMutation.isError && editCouponMutation.error.response.data.max_coupon_value && (
                                    <FormFeedback invalid>
                                        {editCouponMutation.error.response.data.max_coupon_value}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {advancedOptions && (
                            <FormGroup>
                                <Label for="coupon-minimum_cart_value">Minimum Cart Value</Label>
                                <Input
                                    type="text"
                                    name="coupon-minimum_cart_value"
                                    id="coupon-minimum_cart_value"
                                    placeholder="Coupon Minimum Cart Value"
                                    value={couponMinimumCartValue}
                                    onChange={(e) =>
                                        setCouponMinimumCartValue(e.target.value)
                                    }
                                    invalid={
                                        editCouponMutation.isError &&
                                        editCouponMutation.error.response.data.minimum_cart_value
                                    }
                                />
                                {editCouponMutation.isError && editCouponMutation.error.response.data.minimum_cart_value && (
                                    <FormFeedback invalid>
                                        {editCouponMutation.error.response.data.minimum_cart_value}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {/*{advancedOptions && (*/}
                        {/*    <FormGroup>*/}
                        {/*        <Label for="coupon-stock">Stock</Label>*/}
                        {/*        <Input*/}
                        {/*            type="text"*/}
                        {/*            name="coupon-stock"*/}
                        {/*            id="coupon-stock"*/}
                        {/*            placeholder="Coupon Stock"*/}
                        {/*            value={couponStock}*/}
                        {/*            onChange={(e) =>*/}
                        {/*                setCouponStock(e.target.value)*/}
                        {/*            }*/}
                        {/*            invalid={*/}
                        {/*                editCouponMutation.isError &&*/}
                        {/*                editCouponMutation.error.response.data.stock*/}
                        {/*            }*/}
                        {/*        />*/}
                        {/*        {editCouponMutation.isError && editCouponMutation.error.response.data.stock && (*/}
                        {/*            <FormFeedback invalid>*/}
                        {/*                {editCouponMutation.error.response.data.stock}*/}
                        {/*            </FormFeedback>*/}
                        {/*        )}*/}
                        {/*    </FormGroup>*/}
                        {/*)}*/}
                        {advancedOptions && (
                            <FormGroup className="form-group mb-3">
                                <div className="custom-control custom-checkbox">
                                    <Input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="coupon-firstOrder"
                                        checked={couponEligibleForFirstOrder}
                                        onChange={() => setCouponEligibleForFirstOrder(!couponEligibleForFirstOrder)}
                                        invalid={
                                            editCouponMutation.isError &&
                                            editCouponMutation.error.response.data.eligible_for_first_order_only
                                        }
                                    />
                                    <label
                                        className="custom-control-label"
                                        htmlFor="coupon-firstOrder"
                                    >
                                        Eligible For First Order
                                    </label>
                                </div>
                                {editCouponMutation.isError && editCouponMutation.error.response.data.eligible_for_first_order_only && (
                                    <FormFeedback invalid>
                                        {editCouponMutation.error.response.data.eligible_for_first_order_only}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {/*{advancedOptions && (*/}
                        {/*    <FormGroup>*/}
                        {/*        <Label for="coupon-applicalbe">Applicable To</Label>*/}
                        {/*        <Input*/}
                        {/*            type="select"*/}
                        {/*            name="coupon-applicalbe"*/}
                        {/*            id="coupon-applicalbe"*/}
                        {/*            className={"form-control"}*/}
                        {/*            placeholder="Coupon Applicalbe To"*/}
                        {/*            value={couponApplicableTo}*/}
                        {/*            onChange={(e) =>*/}
                        {/*                setCouponApplicableTo(e.target.value)*/}
                        {/*            }*/}
                        {/*            invalid={*/}
                        {/*                editCouponMutation.isError &&*/}
                        {/*                editCouponMutation.error.response.data.applicable_to*/}
                        {/*            }*/}
                        {/*        >*/}
                        {/*            <option value={'CART'}>*/}
                        {/*                Cart*/}
                        {/*            </option>*/}
                        {/*            <option value={'CART-ITEM'}>*/}
                        {/*                Cart Items*/}
                        {/*            </option>*/}
                        {/*            <option value={'BOTH'}>*/}
                        {/*                Both*/}
                        {/*            </option>*/}
                        {/*        </Input>*/}
                        {/*        {editCouponMutation.isError && editCouponMutation.error.response.data.applicable_to && (*/}
                        {/*            <FormFeedback invalid>*/}
                        {/*                {editCouponMutation.error.response.data.applicable_to}*/}
                        {/*            </FormFeedback>*/}
                        {/*        )}*/}
                        {/*    </FormGroup>*/}
                        {/*)}*/}

                        <Button
                            color="#4d5bed"
                            className="bx-btn-primary"
                            block
                            disabled={editCouponMutation.isLoading}
                            type="submit"
                        >
                            {editCouponMutation.isLoading ? <><Loader size={'small'}/> Editing
                                Coupon...</> : `Update Coupon`}

                        </Button>
                    </Form>
                </ModalBody>
            </Modal>
        </td>
    );
}

export default ActionButton;